<!-- App.svelte -->
<script>
import { Navigate, navigateTo } from 'svelte-router-spa'
import { name } from "./store";

let placeholder = "스캇";

function getWindowHeight(){
    return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
}

let a = getWindowHeight();

let textColor = 'black';
let textAni = '';
function clickContinue() {
    if ($name) {
        navigateTo('test1');
    } else {
        textColor = '#ad1305';
        textAni = 'text_shake';

        setTimeout(function(){
            textAni = '';
        }, 500);
    }
}

</script>


<style lang="scss">
  .hero-body {
      background: #f5f5f6;   
  }

body, html {
  -moz-font-smoothing: antialiased;
  -ms-font-smoothing: antialiased;
  -webkit-font-smoothing: antialiased;
  font-smoothing: antialiased;
  -ms-overflow-style: scrollbar;
  -webkit-text-size-adjust: 100%;
  display: block;
  position: fixed;
  background: #f5f5f6;
  -webkit-tap-highlight-color: transparent; 
}

body * { touch-action: none;  } /* scroll disable */

.columns.is-vcentered {
  -webkit-box-align: center;
     -ms-flex-align: center;
        align-items: center;
}

.center {
    margin-left: auto;
    margin-right: auto;
}

.columns.is-vcentered {
  -webkit-box-align: center;
     -ms-flex-align: center;
        align-items: center;
}

  .control.has-icons-left,
  .control.has-icons-right {
    & .icon {
      pointer-events: inherit;
      transition: color 0.5s;
      cursor: pointer;

      &:hover {
        color: #363636;
      }
    }

    & .input:focus ~ .icon {
      color: #dbdbdb;
    }
  }

  .is-colored {
    border-color: #36765a;
    border-width: 2px;
    border-radius: 0px;
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
  
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
  
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }

  .text_shake {
    animation: shake 0.5s;
  }

</style>

<body style="height: {a}px;">
<div class="container has-text-centered" style="height: 100%">
<div class="columns is-mobile is-vcentered" style="height: 100%">
<div class="column center">

<div class="container m-5 has-text-left center">
<div class="container" style="max-width: 500px;">
<h2 class="subtitle is-6 mb-2 {textAni}" style="margin-top: 100px; color: {textColor};">MMTI가 궁금한 반려견의 이름을 입력하세요.</h2>


<div class="field">
  <div
    class="control has-icons-left has-icons-right">
    <input class="input is-colored" type="text" {placeholder} bind:value={$name} />
    <span class="icon is-small is-left">
      <img src="/home_logo.png" style="width: 60%;">
    </span>
  </div>
</div>
</div>
</div>

<div class="container" style="margin-top: 150px;">
<figure class="image is-128x128 center" style="width: 150px; cursor: pointer;" on:click={() => clickContinue() }><img src="/next.png">
<h1 class ="title is-6 is-overlay mt-4 mr-5 has-text-white has-text-centered"><p>다음</p></h1>
</figure>
</div>


</div>
</div>
</body>
